import React, { useEffect, useRef } from "react";
import { Stage as PixiStage } from "@pixi/react";
import { ReactReduxContext } from "react-redux";
import ContextBridge from "../ContextBridge/ContextBridge";

const Stage = ({ dimensions, children }) => {
  const stageRef = useRef(null);

  useEffect(() => {
    if (stageRef.current) {
      globalThis.__PIXI_STAGE__ = stageRef.current.app.stage;
      globalThis.__PIXI_RENDERER__ = stageRef.current.app.renderer;
      globalThis.__PIXI_STAGE__.sortableChildren = true;
    }
  }, []);

  return (
    <ContextBridge
      Context={ReactReduxContext}
      render={(bridgeChildren) => (
        <PixiStage
          ref={stageRef}
          width={dimensions.width}
          height={dimensions.height}
        >
          {bridgeChildren}
        </PixiStage>
      )}
    >
      {children}
    </ContextBridge>
  );
};

export default Stage;
